
















































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';


@Component({
    name:'FoldersTreeNodeMobile'
})
export default class FoldersTreeNodeMobile extends Vue {
    @Prop() data?: FoldersTreeNodeDataMobile;
    @Prop() isSelectable?: boolean;
    
   
    isSelected = false;
    @Watch('isSelected')
    onSelectionChanged(nVal: boolean, oVal: boolean){
        if(this.data)
            this.$emit("selected-changed",{isSelected: nVal , id: this.data.url});
    }
    onChildSelectionChanged(selection: any){
        this.$emit("selected-changed",selection);
    }
    isOpen = false;
    toggle(){
        if(this.data === undefined) return;
        if(this.data.children.length === 0) return;
        this.isOpen = !this.isOpen;
    }

    created(){
        if(this.data === undefined) return;
        if(this.data.children.length === 0 || this.data.children === undefined) this.isOpen = true;
    }

    async onFolderClicked(){
        if(this.data)
        {
            //this.data.isSelected = true;
           await  this.$emit('folder-clicked',this.data.name);
        }
    }
    async onChildFolderClicked(name: string){
        await this.$emit('folder-clicked',name);
    }
    titleDblClick(){
        this.isOpen = !this.isOpen;
    }

   
}


export interface FoldersTreeNodeDataMobile {
    isRoot: boolean;
    name: string;
    id: string;
    iconClass: any;
    url: string;
    children: FoldersTreeNodeDataMobile[];
    isSelected: boolean;
}


